module.exports = __webpack_public_path__ + "media/svgs/Tanzfabrik_Signet-red-7e1efed8d70c16a99aab33ea74011776.svg";